import axiosInstance from '../utils/axiosInstance';

export const fetchSalaryConfigs = async (teacherId = null) => {
  const params = teacherId ? `?teacherId=${teacherId}` : '';
  const { data } = await axiosInstance.get(`/teacher-salary/configs${params}`);
  return data;
};

export const createSalaryConfig = async (payload) => {
  const { data } = await axiosInstance.post('/teacher-salary/configs', payload);
  return data;
};

export const updateSalaryConfig = async (id, payload) => {
  const { data } = await axiosInstance.put(`/teacher-salary/configs/${id}`, payload);
  return data;
};

export const deleteSalaryConfig = async (id) => {
  const { data } = await axiosInstance.delete(`/teacher-salary/configs/${id}`);
  return data;
};

export const getWorkingDays = async (month, year) => {
  const { data } = await axiosInstance.get(`/teacher-salary/working-days?month=${month}&year=${year}`);
  return data;
};

export const calculateSalary = async (month, year, teacherId = null) => {
  const params = new URLSearchParams({ month, year });
  if (teacherId) params.append('teacherId', teacherId);
  const { data } = await axiosInstance.post(`/teacher-salary/calculate?${params}`);
  return data;
};

export const fetchSalarySlips = async (month = null, year = null, teacherId = null) => {
  const params = new URLSearchParams();
  if (month) params.append('month', month);
  if (year) params.append('year', year);
  if (teacherId) params.append('teacherId', teacherId);
  const q = params.toString() ? `?${params}` : '';
  const { data } = await axiosInstance.get(`/teacher-salary/slips${q}`);
  return data;
};

export const fetchSalarySlipById = async (id) => {
  const { data } = await axiosInstance.get(`/teacher-salary/slips/${id}`);
  return data;
};

export const updateSlipStatus = async (id, status) => {
  const { data } = await axiosInstance.patch(`/teacher-salary/slips/${id}/status`, { status });
  return data;
};
